import { createAction } from 'actions/utils';
import {
    CLEAR_CRUD_EVENT,
    DELETE_EVENT_SUCCESS,
    GET_CRUD_EVENT_REQUEST,
    GET_CRUD_EVENT_SUCCESS,
    GET_CRUD_EVENT_ERROR,
    GET_CUSTOM_EVENT_TYPE_PARAMS_REQUEST,
    GET_CUSTOM_EVENT_TYPE_PARAMS_SUCCESS,
    GET_CUSTOM_EVENT_TYPE_PARAMS_ERROR,
    GET_CUSTOM_EVENTS_REQUEST,
    GET_CUSTOM_EVENTS_SUCCESS,
    GET_CUSTOM_EVENTS_ERROR,
} from 'constants/ActionTypes';
import { Core } from 'managers';

export function getEvents() {
    return (dispatch) => {
        dispatch(createAction(GET_CUSTOM_EVENTS_REQUEST, {}));
        return Core.customEventsManager.getEvents().then(
            (res) => {
                dispatch(createAction(GET_CUSTOM_EVENTS_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_CUSTOM_EVENTS_ERROR, error));
                throw error;
            },
        );
    };
}

export function getEventTypeParams() {
    return (dispatch) => {
        dispatch(createAction(GET_CUSTOM_EVENT_TYPE_PARAMS_REQUEST, {}));
        return Core.customEventsManager.getEventTypeParams().then(
            (res) => {
                dispatch(createAction(GET_CUSTOM_EVENT_TYPE_PARAMS_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_CUSTOM_EVENT_TYPE_PARAMS_ERROR, error));
                throw error;
            },
        );
    };
}

export function getCrudEvent({ name }) {
    return (dispatch) => {
        dispatch(createAction(GET_CRUD_EVENT_REQUEST, {}));
        return Core.customEventsManager.getCrudEvent(name).then(
            (res) => {
                dispatch(createAction(GET_CRUD_EVENT_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_CRUD_EVENT_ERROR, error));
                throw error;
            },
        );
    };
}

export function clearCurrentEvent() {
    return (dispatch) => {
        dispatch(createAction(CLEAR_CRUD_EVENT, {}));
    };
}

export function deleteEvent(name) {
    return (dispatch) =>
        new Promise((resolve, reject) => {
            Core.customEventsManager.deleteEvent(name).then(
                (res) => {
                    if (res && res.code === 1) {
                        dispatch(createAction(DELETE_EVENT_SUCCESS, name));
                        resolve(res);
                    } else {
                        reject();
                    }
                },
                (error) => {
                    reject(error);
                },
            );
        });
}
